<template>
    <div class="page">
        <div class="btn-line">
            <div class="btn" @click="applySupplier">申请成为供应商</div>
        </div>
        <div class="list">
            <div class="title">申请记录</div>
            <div class="item" v-for="item in list" :key="item.id">
                <div class="line">
                    <div class="key">申请时间</div>
                    <div class="value">{{ item.createTime }}</div>
                </div>
                <div class="line">
                    <div class="key">状态</div>
                    <div class="value">{{ item.statusDesc }}</div>
                </div>
                <template v-if="item.status == -5">
                    <div class="line">
                        <div class="key">拒绝时间</div>
                        <div class="value">{{ item.rejectTime }}</div>
                    </div>
                    <div class="line">
                        <div class="key">拒绝理由</div>
                        <div class="value">{{ item.rejectReason }}</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [],
            listQuery: {
                pageIndex: 1,
                pageSize: 20,
            },
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData(type = 0) {
            this.$util.post(`/api/supplierApply/pagedQuery`, this.listQuery).then(res => {
                if (res.success) {
                    this.list = res.data;
                }
            });
        },
        applySupplier() {
            this.$util
                .post('/api/supplierApply/apply', {
                    miniUserId: this.$route.query.miniUserId,
                })
                .then(res => {
                    if (res.success) {
                        this.$toast(`申请成功，等待管理员审核`);
                        this.getData();
                    }
                });
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
.btn-line {
    display: flex;
    justify-content: center;
    align-items: center;
    height: .pxToRem(200) [];
    .btn {
        height: .pxToRem(60) [];
        line-height: .pxToRem(60) [];
        padding: 0 .pxToRem(20) [];
        background: @theme_color_first;
        font-size: .pxToRem(24) [];
        color: rgba(0, 0, 0, 0.9);
        border-radius: .pxToRem(4) [];
        box-shadow: 1px 2px 5px rgb(150, 150, 150, 0.1);
    }
}
.list {
    padding: 0 .pxToRem(40) [];
    .title {
        height: .pxToRem(64) [];
        line-height: .pxToRem(64) [];
        font-size: .pxToRem(28) [];
    }
    .item {
        background: white;
        box-shadow: 1px 2px 5px rgba(150, 150, 150, 0.2);
        margin-bottom: .pxToRem(20) [];
        .line {
            display: flex;
            justify-content: space-between;
            height: .pxToRem(60) [];
            line-height: .pxToRem(60) [];
            border-radius: .pxToRem(4) [];
            border-bottom: 1px solid #f6f6f6;
            .key {
                padding-left: .pxToRem(20) [];
            }
            .value {
                padding-right: .pxToRem(20) [];
            }
            &:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>
